(function () {
  var SMALL = /_200x200\./;
  var LARGE = '_600x600.';
  function readTiers(el) {
    var raw = el && el.getAttribute('data-tiers');
    if (!raw) return null;
    var out = [0];
    var parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (!/^\d+(?:\.\d{1,2})?$/.test(part)) return null;
      var n = parseFloat(part);
      if (!isFinite(n) || n <= 0) return null;
      out.push(n);
    }
    return out.length > 1 ? out : null;
  }

  function upsize(img) {
    var src = img.getAttribute('src') || '';
    if (!SMALL.test(src)) return;
    img.removeAttribute('srcset');
    img.setAttribute('src', src.replace(SMALL, LARGE));
  }
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('.moonbundle-dynamic-popup-product-card img');
    for (var i = 0; i < imgs.length; i++) upsize(imgs[i]);
  }

  var root = document.querySelector('[data-vw-compose]');
  var tiersEl = root && root.querySelector('[data-vw-tiers]');
  var pickEl = root && root.querySelector('[data-vw-pick]');
  var summaryEl = root && root.querySelector('[data-vw-pick-summary]');
  var nudgeEl = root && root.querySelector('[data-vw-pick-nudge]');
  var counterEl = root && root.querySelector('[data-vw-pick-counter] span');
  var tiles = pickEl ? Array.prototype.slice.call(pickEl.querySelectorAll('[data-vw-tile]')) : [];
  var TIERS = readTiers(root);
  var UNIT = TIERS ? TIERS[1] : 0;
  var MAX = pickEl ? parseInt(pickEl.getAttribute('data-max'), 10) || 0 : 0;
  if (MAX < 1) MAX = TIERS ? TIERS.length - 1 : 5;
  if (TIERS && MAX >= TIERS.length) MAX = TIERS.length - 1;
  var inline = false;
  var busy = false;
  var queue = [];
  var pending = {};
  var hasPack = false;
  var LABEL_UPDATE = 'Mettre à jour mon pack';
  var labelOriginal = null;

  function packScope() {
    var el = root;
    while (el && el !== document.body) {
      if (el.querySelector && el.querySelector('button.add-to-cart')) return el;
      el = el.parentElement;
    }
    return document;
  }
  function labelButton() {
    if (!root) return;
    var btn = packScope().querySelector('button.add-to-cart');
    if (!btn) return;
    var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var v = n.nodeValue.trim();
      if (!v) continue;
      if (labelOriginal === null && v !== LABEL_UPDATE) labelOriginal = v;
      var want = hasPack ? LABEL_UPDATE : labelOriginal;
      if (want && v !== want && (v === labelOriginal || v === LABEL_UPDATE)) n.nodeValue = n.nodeValue.replace(v, want);
    }
  }

  function cartPackTitles() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return null;
        var titles = [];
        for (var i = 0; i < c.items.length; i++) {
          var it = c.items[i];
          if (it.properties && it.properties.__moonbundle !== undefined && titles.indexOf(it.product_title) === -1) titles.push(it.product_title);
        }
        return titles;
      })
      .catch(function () { return null; });
  }

  function storedCount() {
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (!k || k.indexOf('moonbundle_bm_') !== 0) continue;
        var st = JSON.parse(localStorage.getItem(k));
        var sel = st && st.offerId && st.slotVariantSelections && st.slotVariantSelections[st.offerId];
        if (!sel) continue;
        var n = 0;
        for (var slot in sel) {
          if (!sel.hasOwnProperty(slot) || !sel[slot] || !sel[slot].length) continue;
          for (var j = 0; j < sel[slot].length; j++) if (sel[slot][j] && sel[slot][j].available !== false) { n++; break; }
        }
        return n;
      }
      return 0;
    } catch (e) { return null; }
  }
  function restored() {
    var expected = storedCount();
    if (expected === 0) return Promise.resolve();
    return new Promise(function (resolve) {
      var last = resolvedTitles().join('|');
      var stable = 0;
      var start = Date.now();
      (function tick() {
        var cur = resolvedTitles().join('|');
        if (cur === last) stable += 100; else { stable = 0; last = cur; }
        var n = resolvedTitles().length;
        if (expected !== null && n >= expected) return resolve();
        if (expected === null && stable >= 800) return resolve();
        if (Date.now() - start > 4000) return resolve();
        setTimeout(tick, 100);
      })();
    });
  }

  var userTouched = false;
  var ready = false;

  function reconcile(titles) {
    var have = resolvedTitles();
    have.forEach(function (t) {
      if (titles.indexOf(t) !== -1 || pending.hasOwnProperty(t)) return;
      pending[t] = false;
      queue.push({ title: t, fn: function () { return deselectTitle(t).catch(function () {}); } });
    });
    titles.forEach(function (t) {
      if (have.indexOf(t) !== -1 || pending.hasOwnProperty(t)) return;
      var tile = tiles.filter(function (x) { return x.getAttribute('data-title') === t; })[0];
      if (!tile || tile.disabled || engaged() >= MAX) return;
      pending[t] = true;
      queue.push({ title: t, fn: function () { return selectTitle(t).catch(function () {}); } });
    });
    syncState();
    run();
  }

  var urlDone = false;
  function urlTitles() {
    if (urlDone) return [];
    var m = /[?&]pack=([^&]*)/.exec(window.location.search);
    if (!m) return [];
    var out = [];
    decodeURIComponent(m[1]).split(',').forEach(function (v) {
      var num = v.trim();
      if (!num) return;
      var t = tiles.filter(function (x) { return x.getAttribute('data-num') === num; })[0];
      if (!t || t.disabled) return;
      var title = t.getAttribute('data-title');
      if (out.indexOf(title) === -1) out.push(title);
    });
    return out.slice(0, MAX);
  }
  function union(a, b) {
    var out = a.slice();
    b.forEach(function (t) { if (out.indexOf(t) === -1) out.push(t); });
    return out;
  }
  function idle() { return ready && !busy && !queue.length; }
  function whenIdle(limit) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function tick() {
        if (idle() || Date.now() - start > limit) return resolve();
        setTimeout(tick, 100);
      })();
    });
  }

  function syncFromCart() {
    return Promise.all([cartPackTitles(), restored()]).then(function (r) {
      var titles = r[0];
      var wanted = urlTitles();
      hasPack = !!(titles && titles.length);
      labelButton();
      cartTitles = null;
      ready = true;
      if (hasPack && !userTouched) reconcile(union(titles, wanted));
      else applyUrlSelection();
      if (wanted.length) userTouched = true;
      urlDone = true;
      run();
    });
  }

  function resync() {
    if (!inline || !ready) return;
    cartPackTitles().then(function (titles) {
      if (titles === null) return;
      hasPack = titles.length > 0;
      labelButton();
      if (hasPack && !userTouched && idle()) reconcile(titles);
    });
  }

  var deferring = false;
  var forced = false;
  function onSubmitClick(e) {
    if (!inline || forced || deferring || idle()) return;
    var btn = e.target && e.target.closest ? e.target.closest('button.add-to-cart') : null;
    if (!btn) return;
    var scope = packScope();
    if (scope !== document && !scope.contains(btn)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    deferring = true;
    whenIdle(6000).then(function () {
      deferring = false;
      forced = true;
      try { btn.click(); } finally { forced = false; }
    });
  }

  function euros(v) {
    var n = Math.round(v * 100) / 100;
    return (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ',')) + ' €';
  }
  function onAdded() { hasPack = true; userTouched = false; labelButton(); }
  function packTitlesOf(items) {
    var titles = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && it.properties && it.properties.__moonbundle !== undefined && titles.indexOf(it.product_title) === -1) titles.push(it.product_title);
    }
    return titles;
  }
  var cartTitles = null;
  function applyCartTitles() {
    if (cartTitles === null || !inline || !ready || !idle()) return;
    var titles = cartTitles;
    cartTitles = null;
    hasPack = titles.length > 0;
    labelButton();
    if (hasPack && !userTouched) reconcile(titles);
  }
  function onCart(e) {
    if (!ready || !e || !e.detail || !Array.isArray(e.detail.items)) return;
    cartTitles = packTitlesOf(e.detail.items);
    applyCartTitles();
  }

  function resolvedTitles() {
    return Array.prototype.map.call(document.querySelectorAll('.moonbundle-mp-slot-card--resolved .moonbundle-mp-line-product-title'), function (t) { return t.textContent.trim(); });
  }
  function widgetReady() { return !!document.querySelector('.moonbundle-mp-slot-card'); }
  function engaged() {
    var n = resolvedTitles().length;
    for (var k in pending) if (pending.hasOwnProperty(k) && pending[k]) n++;
    return n;
  }

  function syncState() {
    var titles = resolvedTitles();
    var count = titles.length;
    if (tiersEl) {
      var steps = tiersEl.querySelectorAll('[data-count]');
      var cur = Math.min(count, 5);
      for (var i = 0; i < steps.length; i++) {
        var n = parseInt(steps[i].getAttribute('data-count'), 10);
        steps[i].classList.toggle('is-active', count > 0 && n === cur);
        steps[i].classList.toggle('is-reached', count > 0 && n < cur);
      }
      tiersEl.classList.toggle('has-selection', count > 0);
    }
    if (!pickEl) return;
    tiles.forEach(function (t) {
      var title = t.getAttribute('data-title');
      var on = pending.hasOwnProperty(title) ? pending[title] : titles.indexOf(title) !== -1;
      var want = on ? 'true' : 'false';
      if (t.getAttribute('aria-pressed') !== want) t.setAttribute('aria-pressed', want);
      if (t.classList.contains('is-on') !== on) t.classList.toggle('is-on', on);
    });
    pickEl.classList.toggle('is-full', count >= MAX);
    if (pickEl.getAttribute('data-count') !== String(count)) pickEl.setAttribute('data-count', String(count));
    if (counterEl && counterEl.textContent !== String(count)) counterEl.textContent = String(count);
    if (summaryEl) {
      var frag = document.createDocumentFragment();
      var priced = !!(TIERS && count < TIERS.length);
      var price = priced ? TIERS[count] : 0;
      var full = priced ? UNIT * count : 0;
      var saving = full - price;
      if (count === 0) frag.appendChild(document.createTextNode('Sélectionne au moins un numéro.'));
      else {
        var main = document.createElement('span');
        main.className = 'vw-pick__summary-main';
        var strong = document.createElement('strong');
        strong.textContent = count + ' numéro' + (count > 1 ? 's' : '') + (priced ? ' · ' + euros(price) : '');
        main.appendChild(strong);
        if (saving > 0) {
          var s = document.createElement('s');
          s.textContent = 'au lieu de ' + euros(full);
          main.appendChild(s);
        }
        frag.appendChild(main);
        if (saving > 0) {
          var em = document.createElement('em');
          em.className = 'vw-pick__badge';
          em.textContent = euros(saving) + ' économisés';
          frag.appendChild(em);
        }
      }
      var next = document.createElement('div');
      next.appendChild(frag.cloneNode(true));
      if (summaryEl.innerHTML !== next.innerHTML) {
        summaryEl.textContent = '';
        summaryEl.appendChild(frag);
      }
    }
    if (nudgeEl) {
      var msg = '';
      if (TIERS && count > 0 && count < MAX && count + 1 < TIERS.length) {
        var step = TIERS[count + 1] - TIERS[count];
        var nextSaving = UNIT * (count + 1) - TIERS[count + 1];
        msg = 'Un numéro de plus : ' + euros(step) + ' seulement, et tu économises ' + euros(nextSaving) + ' en tout.';
      } else if (TIERS && count >= MAX && MAX < TIERS.length) {
        msg = 'Le pack complet : ' + euros(TIERS[MAX] / MAX) + ' le numéro, le meilleur prix.';
      }
      if (nudgeEl.textContent !== msg) nudgeEl.textContent = msg;
      if (nudgeEl.hidden !== !msg) nudgeEl.hidden = !msg;
    }
    if (inline) untab(document.querySelector('moonbundle-component.vw-hidden-widget'));
    labelButton();
  }

  function waitFor(test, timeout) {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      (function tick() {
        var r = test();
        if (r) return resolve(r);
        if (Date.now() - start > timeout) return reject(new Error('timeout'));
        setTimeout(tick, 60);
      })();
    });
  }
  function deepest(el) {
    var cur = el;
    while (cur && cur.firstElementChild) cur = cur.firstElementChild;
    return cur || el;
  }
  function lastPicker() {
    var all = document.querySelectorAll('[data-type="slot-dynamic-picker"]');
    return all.length ? all[all.length - 1] : null;
  }

  var FOCUSABLE = 'a[href],button,input,select,textarea,[tabindex]';
  function untab(root) {
    if (!root) return;
    var els = root.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-vw-untab') === '1') continue;
      els[i].setAttribute('data-vw-untab', '1');
      els[i].setAttribute('data-vw-tabindex', els[i].hasAttribute('tabindex') ? els[i].getAttribute('tabindex') : '');
      els[i].setAttribute('tabindex', '-1');
    }
  }
  function retab(root) {
    if (!root) return;
    var els = root.querySelectorAll('[data-vw-untab="1"]');
    for (var i = 0; i < els.length; i++) {
      var prev = els[i].getAttribute('data-vw-tabindex');
      if (prev) els[i].setAttribute('tabindex', prev);
      else els[i].removeAttribute('tabindex');
      els[i].removeAttribute('data-vw-untab');
      els[i].removeAttribute('data-vw-tabindex');
    }
  }

  var fellBack = false;
  function fallback() {
    inline = false;
    queue.length = 0;
    for (var k in pending) if (pending.hasOwnProperty(k)) delete pending[k];
    document.documentElement.classList.remove('vw-inline-on');
    if (pickEl) pickEl.hidden = true;
    var comp = document.querySelector('moonbundle-component.vw-hidden-widget');
    if (comp) {
      comp.classList.remove('vw-hidden-widget');
      comp.removeAttribute('aria-hidden');
      retab(comp);
    }
    if (!fellBack) {
      fellBack = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'views_compose_fallback', product: 'compose-ton-pack' });
      } catch (e) {}
    }
  }

  function selectTitle(title) {
    if (resolvedTitles().indexOf(title) !== -1) return Promise.resolve();
    return waitFor(function () { return document.querySelector('.moonbundle-mp-slot-card--empty'); }, 1500)
      .catch(function () { throw new Error('aucun emplacement libre'); })
      .then(function (empty) { return ouvrirEtChoisir(empty, title); });
  }
  function ouvrirEtChoisir(empty, title) {
    var before = document.querySelectorAll('[data-type="slot-dynamic-picker"]').length;
    deepest(empty).click();
    return waitFor(function () {
      var p = lastPicker();
      if (!p) return null;
      var cards = p.querySelectorAll('.moonbundle-dynamic-popup-product-card');
      if (document.querySelectorAll('[data-type="slot-dynamic-picker"]').length <= before && !cards.length) return null;
      for (var i = 0; i < cards.length; i++) {
        var t = cards[i].querySelector('.moonbundle-dynamic-popup-product-title');
        if (t && t.textContent.trim() === title) return cards[i].querySelector('.moonbundle-dynamic-popup-cta');
      }
      return null;
    }, 4000).then(function (cta) {
      cta.click();
      return waitFor(function () { return resolvedTitles().indexOf(title) !== -1; }, 4000);
    });
  }
  function deselectTitle(title) {
    var cards = document.querySelectorAll('.moonbundle-mp-slot-card--resolved');
    for (var i = 0; i < cards.length; i++) {
      var t = cards[i].querySelector('.moonbundle-mp-line-product-title');
      if (t && t.textContent.trim() === title) {
        var carte = cards[i];
        return waitFor(function () { return carte.querySelector('.moonbundle-mp-slot-line-clear'); }, 1500)
          .catch(function () { throw new Error('retrait impossible'); })
          .then(function (clear) {
            clear.click();
            return waitFor(function () { return resolvedTitles().indexOf(title) === -1; }, 4000);
          });
      }
    }
    return Promise.resolve();
  }

  function run() {
    if (busy || !ready || !queue.length) return;
    busy = true;
    if (pickEl) pickEl.setAttribute('aria-busy', 'true');
    var job = queue.shift();
    Promise.resolve().then(function () { return job.fn(); }).catch(fallback).then(function () {
      delete pending[job.title];
      busy = false;
      if (pickEl) pickEl.removeAttribute('aria-busy');
      syncState();
      run();
      if (!queue.length) applyCartTitles();
    });
  }
  function onTile(e) {
    if (!inline) return;
    userTouched = true;
    var tile = e.currentTarget;
    var title = tile.getAttribute('data-title');
    var on = tile.getAttribute('aria-pressed') === 'true';
    if (pending.hasOwnProperty(title)) return;
    if (busy && !on) { return; }
    if (!on && engaged() >= MAX) { syncState(); return; }
    pending[title] = !on;
    tile.setAttribute('aria-pressed', on ? 'false' : 'true');
    tile.classList.toggle('is-on', !on);
    queue.push({ title: title, fn: function () { return on ? deselectTitle(title) : selectTitle(title); } });
    run();
  }

  var syncTimer = 0;
  function scheduleSync() {
    if (syncTimer) return;
    syncTimer = window.setTimeout(function () { syncTimer = 0; syncState(); }, 80);
  }

  var observer = new MutationObserver(function (mutations) {
    var touched = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes') {
        if (m.attributeName === 'src') {
          if (m.target.closest && m.target.closest('.moonbundle-dynamic-popup-product-card')) upsize(m.target);
        } else touched = true;
        continue;
      }
      touched = true;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') { if (n.closest('.moonbundle-dynamic-popup-product-card')) upsize(n); }
        else scan(n);
      }
    }
    if (touched) scheduleSync();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class'] });
  scan(document);

  function applyUrlSelection() {
    var m = /[?&]pack=([^&]*)/.exec(window.location.search);
    if (!m) return;
    var wanted = decodeURIComponent(m[1]).split(',').map(function (v) { return v.trim(); }).filter(Boolean).slice(0, MAX);
    if (!wanted.length) return;
    var already = resolvedTitles();
    wanted.forEach(function (num) {
      if (engaged() >= MAX) return;
      var t = tiles.filter(function (x) { return x.getAttribute('data-num') === num; })[0];
      if (!t || t.disabled) return;
      var title = t.getAttribute('data-title');
      if (already.indexOf(title) !== -1 || pending.hasOwnProperty(title)) return;
      pending[title] = true;
      t.setAttribute('aria-pressed', 'true');
      t.classList.add('is-on');
      queue.push({ title: title, fn: function () { return selectTitle(title); } });
    });
    run();
  }

  if (pickEl && tiles.length) {
    tiles.forEach(function (t) { t.addEventListener('click', onTile); });
    document.addEventListener('baseline:productform:success', onAdded, true);
    window.addEventListener('baseline:cart:afteradditem', onAdded, true);
    document.addEventListener('click', onSubmitClick, true);
    document.addEventListener('vw:cart', onCart);
    window.addEventListener('pageshow', function (e) { if (e.persisted) resync(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) resync(); });
    waitFor(widgetReady, 12000).then(function () {
      var box = document.querySelector('.moonbundle-box');
      var comp = box && box.closest('moonbundle-component');
      if (!comp) throw new Error('widget');
      comp.classList.add('vw-hidden-widget');
      comp.setAttribute('aria-hidden', 'true');
      untab(comp);
      inline = true;
      document.documentElement.classList.add('vw-inline-on');
      pickEl.hidden = false;
      syncState();
      return syncFromCart();
    }).catch(fallback);
  }
  syncState();
})();
